// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d5600aaf","977":"ef010a14"}[chunkId] + ".chunk.js";
};